export const toDoListMockData = [
    {
        "id": 1366424,
        "name": "Kitchen",
        "category": "kitchen",
        "floor": null,
        "type": "room",
        "tasks": [
            {
                "id": 8816247,
                "title": "Wash dishes",
                "note": null,
                "estimated_time": 10,
                "internal_priority": 25,
                "occurrence": 0,
                "state": "active",
                "order": 25,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816248,
                "title": "Take out trash \u0026 wipe can",
                "note": null,
                "estimated_time": 2,
                "internal_priority": 26,
                "occurrence": 0,
                "state": "active",
                "order": 26,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816249,
                "title": "Mop floors",
                "note": null,
                "estimated_time": 4,
                "internal_priority": 27,
                "occurrence": 0,
                "state": "active",
                "order": 27,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816250,
                "title": "Wipe down surfaces",
                "note": null,
                "estimated_time": 2,
                "internal_priority": 28,
                "occurrence": 0,
                "state": "active",
                "order": 28,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816251,
                "title": "Vacuum floors",
                "note": null,
                "estimated_time": 4,
                "internal_priority": 29,
                "occurrence": 0,
                "state": "active",
                "order": 29,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816252,
                "title": "Wipe down sink",
                "note": null,
                "estimated_time": 1,
                "internal_priority": 30,
                "occurrence": 0,
                "state": "active",
                "order": 30,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816259,
                "title": "Light microwave clean",
                "note": null,
                "estimated_time": 2,
                "internal_priority": 37,
                "occurrence": 0,
                "state": "active",
                "order": 37,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816260,
                "title": "Wipe down all appliances",
                "note": null,
                "estimated_time": 2,
                "internal_priority": 38,
                "occurrence": 0,
                "state": "active",
                "order": 38,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816261,
                "title": "Wipe down cabinets",
                "note": null,
                "estimated_time": 2,
                "internal_priority": 39,
                "occurrence": 0,
                "state": "active",
                "order": 39,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816264,
                "title": "Light refrigerator clean",
                "note": null,
                "estimated_time": 4,
                "internal_priority": 42,
                "occurrence": 0,
                "state": "active",
                "order": 42,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            }
        ],
        "notes": [],
        "photos": []
    },
    {
        "id": 1366425,
        "name": "Bedroom 1",
        "category": "bedroom",
        "floor": null,
        "type": "room",
        "tasks": [
            {
                "id": 8816223,
                "title": "Make bed",
                "note": null,
                "estimated_time": 4,
                "internal_priority": 1,
                "occurrence": 0,
                "state": "active",
                "order": 1,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816225,
                "title": "Wipe down mirrors",
                "note": null,
                "estimated_time": 2,
                "internal_priority": 3,
                "occurrence": 0,
                "state": "active",
                "order": 3,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816227,
                "title": "Mop floors",
                "note": null,
                "estimated_time": 4,
                "internal_priority": 5,
                "occurrence": 0,
                "state": "active",
                "order": 5,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816229,
                "title": "Vacuum floors",
                "note": null,
                "estimated_time": 4,
                "internal_priority": 7,
                "occurrence": 0,
                "state": "active",
                "order": 7,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816243,
                "title": "Dust \u0026 wipe furniture",
                "note": null,
                "estimated_time": 3,
                "internal_priority": 21,
                "occurrence": 0,
                "state": "active",
                "order": 21,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816253,
                "title": "Clean scuffs on doors \u0026 walls",
                "note": null,
                "estimated_time": 3,
                "internal_priority": 31,
                "occurrence": 0,
                "state": "active",
                "order": 31,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816255,
                "title": "Clean inside windows \u0026 sills",
                "note": null,
                "estimated_time": 4,
                "internal_priority": 33,
                "occurrence": 0,
                "state": "active",
                "order": 33,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816257,
                "title": "Wipe down baseboards",
                "note": null,
                "estimated_time": 2,
                "internal_priority": 35,
                "occurrence": 0,
                "state": "active",
                "order": 35,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816262,
                "title": "Dust ceiling fans",
                "note": null,
                "estimated_time": 2,
                "internal_priority": 40,
                "occurrence": 0,
                "state": "active",
                "order": 40,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            }
        ],
        "notes": [],
        "photos": []
    },
    {
        "id": 1366426,
        "name": "Bedroom 2",
        "category": "bedroom",
        "floor": null,
        "type": "room",
        "tasks": [
            {
                "id": 8816224,
                "title": "Make bed",
                "note": null,
                "estimated_time": 4,
                "internal_priority": 2,
                "occurrence": 0,
                "state": "active",
                "order": 2,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816226,
                "title": "Wipe down mirrors",
                "note": null,
                "estimated_time": 2,
                "internal_priority": 4,
                "occurrence": 0,
                "state": "active",
                "order": 4,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816228,
                "title": "Mop floors",
                "note": null,
                "estimated_time": 4,
                "internal_priority": 6,
                "occurrence": 0,
                "state": "active",
                "order": 6,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816230,
                "title": "Vacuum floors",
                "note": null,
                "estimated_time": 4,
                "internal_priority": 8,
                "occurrence": 0,
                "state": "active",
                "order": 8,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816244,
                "title": "Dust \u0026 wipe furniture",
                "note": null,
                "estimated_time": 3,
                "internal_priority": 22,
                "occurrence": 0,
                "state": "active",
                "order": 22,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816254,
                "title": "Clean scuffs on doors \u0026 walls",
                "note": null,
                "estimated_time": 3,
                "internal_priority": 32,
                "occurrence": 0,
                "state": "active",
                "order": 32,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816256,
                "title": "Clean inside windows \u0026 sills",
                "note": null,
                "estimated_time": 4,
                "internal_priority": 34,
                "occurrence": 0,
                "state": "active",
                "order": 34,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816258,
                "title": "Wipe down baseboards",
                "note": null,
                "estimated_time": 2,
                "internal_priority": 36,
                "occurrence": 0,
                "state": "active",
                "order": 36,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816263,
                "title": "Dust ceiling fans",
                "note": null,
                "estimated_time": 2,
                "internal_priority": 41,
                "occurrence": 0,
                "state": "active",
                "order": 41,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            }
        ],
        "notes": [],
        "photos": []
    },
    {
        "id": 1366427,
        "name": "Bathroom 1",
        "category": "bathroom",
        "floor": null,
        "type": "room",
        "tasks": [
            {
                "id": 8816231,
                "title": "Clean toilet",
                "note": null,
                "estimated_time": 2,
                "internal_priority": 9,
                "occurrence": 0,
                "state": "active",
                "order": 9,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816233,
                "title": "Mop floors",
                "note": null,
                "estimated_time": 3,
                "internal_priority": 11,
                "occurrence": 0,
                "state": "active",
                "order": 11,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816235,
                "title": "Wipe down mirrors",
                "note": null,
                "estimated_time": 2,
                "internal_priority": 13,
                "occurrence": 0,
                "state": "active",
                "order": 13,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816237,
                "title": "Wipe down sink \u0026 counters",
                "note": null,
                "estimated_time": 2,
                "internal_priority": 15,
                "occurrence": 0,
                "state": "active",
                "order": 15,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816239,
                "title": "Clean shower \u0026 tub",
                "note": null,
                "estimated_time": 5,
                "internal_priority": 17,
                "occurrence": 0,
                "state": "active",
                "order": 17,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816241,
                "title": "Vacuum floors",
                "note": null,
                "estimated_time": 2,
                "internal_priority": 19,
                "occurrence": 0,
                "state": "active",
                "order": 19,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816245,
                "title": "Wipe down cabinets",
                "note": null,
                "estimated_time": 2,
                "internal_priority": 23,
                "occurrence": 0,
                "state": "active",
                "order": 23,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816265,
                "title": "Clean inside windows \u0026 sills",
                "note": null,
                "estimated_time": 2,
                "internal_priority": 43,
                "occurrence": 0,
                "state": "active",
                "order": 43,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816267,
                "title": "Clean scuffs on doors \u0026 walls",
                "note": null,
                "estimated_time": 3,
                "internal_priority": 45,
                "occurrence": 0,
                "state": "active",
                "order": 45,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816269,
                "title": "Dust blinds",
                "note": null,
                "estimated_time": 2,
                "internal_priority": 47,
                "occurrence": 0,
                "state": "active",
                "order": 47,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            }
        ],
        "notes": [],
        "photos": []
    },
    {
        "id": 1366428,
        "name": "Bathroom 2",
        "category": "bathroom",
        "floor": null,
        "type": "room",
        "tasks": [
            {
                "id": 8816232,
                "title": "Clean toilet",
                "note": null,
                "estimated_time": 2,
                "internal_priority": 10,
                "occurrence": 0,
                "state": "active",
                "order": 10,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816234,
                "title": "Mop floors",
                "note": null,
                "estimated_time": 3,
                "internal_priority": 12,
                "occurrence": 0,
                "state": "active",
                "order": 12,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816236,
                "title": "Wipe down mirrors",
                "note": null,
                "estimated_time": 2,
                "internal_priority": 14,
                "occurrence": 0,
                "state": "active",
                "order": 14,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816238,
                "title": "Wipe down sink \u0026 counters",
                "note": null,
                "estimated_time": 2,
                "internal_priority": 16,
                "occurrence": 0,
                "state": "active",
                "order": 16,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816240,
                "title": "Clean shower \u0026 tub",
                "note": null,
                "estimated_time": 5,
                "internal_priority": 18,
                "occurrence": 0,
                "state": "active",
                "order": 18,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816242,
                "title": "Vacuum floors",
                "note": null,
                "estimated_time": 2,
                "internal_priority": 20,
                "occurrence": 0,
                "state": "active",
                "order": 20,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816246,
                "title": "Wipe down cabinets",
                "note": null,
                "estimated_time": 2,
                "internal_priority": 24,
                "occurrence": 0,
                "state": "active",
                "order": 24,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816266,
                "title": "Clean inside windows \u0026 sills",
                "note": null,
                "estimated_time": 2,
                "internal_priority": 44,
                "occurrence": 0,
                "state": "active",
                "order": 44,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816268,
                "title": "Clean scuffs on doors \u0026 walls",
                "note": null,
                "estimated_time": 3,
                "internal_priority": 46,
                "occurrence": 0,
                "state": "active",
                "order": 46,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            },
            {
                "id": 8816270,
                "title": "Dust blinds",
                "note": null,
                "estimated_time": 2,
                "internal_priority": 48,
                "occurrence": 0,
                "state": "active",
                "order": 48,
                "custom": true,
                "task_type": "cleaning",
                "is_important": false,
                "photo_notes": [],
                "options": [],
                "task_category": null,
                "room_object": null
            }
        ],
        "notes": [],
        "photos": []
    }
]